/* dayjs を vueコンポーネントのテンプレートから $dayjs でアクセスできるようにする */

import { VueConstructor } from 'vue';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat); // フォーマットのカスタマイズを有効化

export default {
    install: (Vue: VueConstructor) => {
        Vue.prototype.$dayjs = function (date?: string | number | Date | dayjs.Dayjs) {
            return dayjs(date);
        };
    },
};

declare module 'vue/types/vue' {
    interface Vue {
        $dayjs: (date?: string | number | Date | dayjs.Dayjs) => dayjs.Dayjs;
    }
}
